import React, { ReactElement } from 'react';
import { Route, RouteProps, Redirect } from 'react-router-dom';
import { hasAccess } from '@portal/utils/hasAccess';
import useReduxState from '@portal/hooks/useReduxState';
import NotFound from '@portal/pages/NotFound/NotFound';

interface ProtectedRouteProps extends RouteProps {
  children: ReactElement;
  roles?: string | string[];
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  roles,
  redirectTo,
  ...routeProps
}) => {
  const {
    user: { roles: userRoles },
  } = useReduxState();

  if (!roles) {
    return <Route {...routeProps}>{children}</Route>;
  }

  const hasPermission = hasAccess(userRoles, roles);

  return (
    <Route {...routeProps}>
      {hasPermission ? (
        children
      ) : redirectTo ? (
        <Redirect to={redirectTo} />
      ) : (
        <NotFound />
      )}
    </Route>
  );
};

export default ProtectedRoute;
